var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.svg)?_c('div',{staticClass:"svg",domProps:{"innerHTML":_vm._s(_vm.svg)}}):_c('img',{attrs:{"alt":_vm.alt,"src":_vm.dataSrc},on:{"load":_vm.load}})
}
var staticRenderFns = []

export { render, staticRenderFns }